<template>
  <div class="ur-sel-main" :class="{ 'is-mobile': isMobile }">
    <div v-show="!isMobile || !mobileShowGrid" class="ur-sel-left">
      <LeftPanel :is-mobile="isMobile" @show-grid="openMobileGrid" />
    </div>
    <div v-show="!isMobile || mobileShowGrid" class="ur-sel-right">
      <RightPanel :is-mobile="isMobile" @back="mobileShowGrid = false" />
    </div>
    <OverSelectDialog v-if="overDialogVisible" @close="closeOver" />
    <IntroDialog v-if="introVisible" @close="introVisible = false" />
    <!-- 手機：目前選配登記 → 進熱度圖時的兩步引導（提醒→圖例）-->
    <GridIntroDialog v-if="mobileGridIntro" @done="mobileGridIntro = false" />
    <ChatEntry />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import UrbanRenewalSelectService from '@/services/UrbanRenewalSelectService';
import LeftPanel from './components/LeftPanel.vue';
import RightPanel from './components/RightPanel.vue';
import OverSelectDialog from './components/OverSelectDialog.vue';
import IntroDialog from './components/IntroDialog.vue';
import GridIntroDialog from './components/GridIntroDialog.vue';
import ChatEntry from './components/ChatEntry.vue';
import responsive from '../responsive';
export default {
  name: 'UrbanRenewalSelect',
  mixins: [responsive],
  components: { LeftPanel, RightPanel, OverSelectDialog, IntroDialog, GridIntroDialog, ChatEntry },
  data() {
    return {
      introVisible: false,
      mobileShowGrid: false,   // 手機單欄：false=試算表(LeftPanel) / true=熱度圖(RightPanel)
      mobileGridIntro: false,  // 手機進熱度圖的兩步引導（提醒→圖例）
    };
  },
  computed: {
    ...mapState('urbanRenewalSelect', ['overDialogVisible']),
  },
  async mounted() {
    this.$store.dispatch('urbanRenewalSelect/initProject');
    // 進場提示：每次登入只彈一次（旗標存 localStorage，登入時重置、重新整理不再彈）
    if (!UrbanRenewalSelectService.introShown()) {
      this.introVisible = true;
      UrbanRenewalSelectService.markIntroShown();
    }
    try {
      await this.$store.dispatch('urbanRenewalSelect/fetchMe');
      await this.$store.dispatch('urbanRenewalSelect/fetchGrid');
      await this.$store.dispatch('urbanRenewalSelect/restoreDraft');
    } catch (e) {
      if (e.response && e.response.status === 401) {
        UrbanRenewalSelectService.clearSession();
        this.$router.push('/urbanrenewal/select/login');
      }
    }
  },
  methods: {
    closeOver() {
      this.$store.commit('urbanRenewalSelect/SET_OVER_DIALOG', false);
    },
    // 手機點「目前選配登記」：切到熱度圖並開啟兩步引導（提醒→圖例）
    openMobileGrid() {
      this.mobileShowGrid = true;
      this.mobileGridIntro = true;
    },
  },
};
</script>
